import MultipleChoiceItem from './multiple-choice-item';

export default MultipleChoiceItem;
